/**
 * Created by Greg on 4/22/2016.
 */
import React from 'react';
import {Panel, Glyphicon} from 'react-bootstrap';
import {NetDrawContainer, NET_ACTION} from './netDraw/NetDraw';
import {NetInfo} from './info/NetInfo';
import {PathInfoContainer} from './info/PathInfo';
import * as helpText from 'html-loader!./../Help.html';
import * as packageInfo from './../package.json';

var NetDrawPanel = React.createClass({
    render: function() {
        let width = parseFloat(this.props.width);
        let height = parseFloat(this.props.height);
        let drawPad = 5;
        let headerHeight = 40;
        return <div className="panel panel-default" style={{width: width, height: height}} >
            <div className="panel-heading"><strong>{this.props.net.graph.name}</strong> Network Visualization</div>
            <div className="panel-body" style={{width: width, height: height - headerHeight, padding: drawPad, overflow:"hidden"}}>
                <NetDrawContainer width={width-2*drawPad} height={height-headerHeight - 2*drawPad}/>
            </div>
        </div>;
    }
})

var NetInfoPanel = React.createClass({
    // This stops event propagation on the panel so mouse drags and such will
    // not cause panel moves and one can interact normally with text.
    mouseDown(e) {
        e.stopPropagation();
    },

    render: function() {
        let width = parseFloat(this.props.width);
        let height = parseFloat(this.props.height);
        let pad = 10;
        let headerHeight = 40;
        let headerStyle = {cursor: "move"}
        let closeStyle = {float: "right", cursor: "pointer"};
        return <div className="panel panel-default" style={{width: width, height: height}}>
            <div className="panel-heading" style={headerStyle}><strong>{this.props.net.graph.name}</strong> Network Info
                <Glyphicon style={closeStyle} onClick={this.props.closeFunc} glyph="remove"/></div>
            <div className="panel-body" style={{width: width,
            height: height - headerHeight, padding: pad, overflow:"hidden"}}
                 onMouseDown={this.mouseDown}>
                <NetInfo net={this.props.net} mode={this.props.mode} nameDescChange={this.props.nameDescChange}
                         demands={this.props.demands} width={width} height={height} />
            </div>
        </div>;
    }
})

var HelpPanel = React.createClass({
    render: function() {
        let width = parseFloat(this.props.width);
        let height = parseFloat(this.props.height);
        let pad = 10;
        let headerHeight = 55;
        let headerStyle = {cursor: "move"}
        let closeStyle = {cursor: "pointer"};
        return <div className="panel panel-default" style={{width: width, height: height}}>
            <div className="panel-heading" style={headerStyle}>Help
                <span style={{float: "right"}}><em><strong>ComNetViz</strong> Version {packageInfo.version}  &nbsp;&nbsp;</em>
                <Glyphicon  style={closeStyle} onClick={this.props.closeFunc} glyph="remove"/></span></div>
            <div id="HelpContents" className="panel-body" style={{width: width, height: height - headerHeight,
                padding: pad, overflowY:"scroll"}} dangerouslySetInnerHTML={{__html: helpText}}>
            </div>
        </div>;
    }
})

var PathInfoPanel = React.createClass({
    // This stops event propagation on the panel so mouse drags and such will
    // not cause panel moves and one can interact normally with text.
    mouseDown(e) {
        e.stopPropagation();
    },

    render: function() {
        let width = parseFloat(this.props.width);
        let height = parseFloat(this.props.height);
        let pad = 10;
        let headerHeight = 40;
        let headerStyle = {cursor: "move"}
        let closeStyle = {float: "right", cursor: "pointer"};
        return <div className="panel panel-default" style={{width: width, height: height}}>
            <div className="panel-heading" style={headerStyle}> Path Info
                <Glyphicon style={closeStyle} onClick={this.props.closeFunc} glyph="remove"/></div>
            <div className="panel-body" style={{width: width,
            height: height - headerHeight, padding: pad, overflow:"hidden"}}
                 onMouseDown={this.mouseDown}>
                <PathInfoContainer width={width} height={height} />
            </div>
        </div>;
    }
})

var Wrapper = React.createClass({
    render: function () {
        var that = this;
        var newChildren = React.Children.map(this.props.children, function(child) {
            return React.cloneElement(child, { width: that.props.style.width,
            height: that.props.style.height})
            });
      return (
        <div {...this.props}>
            {newChildren}
        </div>
      );
    }
});

export {Wrapper, NetDrawPanel, NetInfoPanel, HelpPanel, PathInfoPanel}


// WEBPACK FOOTER //
// ./src/AppPanels.js